import styles from "./Layout.styles.scss";

export const Row = ({children, className, flex, horizontalCenter, verticalCenter, ...others}) => <div className={[styles.row, horizontalCenter && styles.rowHCenter, verticalCenter && styles.rowVCenter, flex && styles.expand, className].join(" ")} {...others}>
  {children}
</div>;

export const Column = ({children, className, flex, horizontalCenter, verticalCenter, ...others}) => <div className={[styles.column, horizontalCenter && styles.columnHCenter, verticalCenter && styles.columnVCenter, flex && styles.expand, className].join(" ")} {...others}>
  {children}
</div>;

export const Expand = ({children}) => <div className={[styles.expand]}>{children}</div>;


// WEBPACK FOOTER //
// ./components/Layout/Layout.js